<template>
  <div class="cb-floatingBtn pr-5" id="cb-floatingBtn">
    <vs-button class="py-2" color="secondary">Help</vs-button>
  </div>
</template>

<script>
// import "/public/chatbot/chatbot.js";
import "/public/chatbot/chatbot.css";

export default {
  name: "chatbot-btn",
  data() {
    return {
      styleOptions: {
        hideUploadButton: true,
        suggestedActionLayout: 'stacked',
        suggestedActionsStackedLayoutButtonTextWrap: true,
        suggestedActionBorderColor: '#feeb1a',
        suggestedActionBackgroundColor: '#fdf39d',
        suggestedActionTextColor: 'black',
        primaryFont: "'Arial', sans-serif"
      },
      chatBotTopBarTitle: "Webchat",
      cbVarButton: null,
      cbVarContainer: null,
      cbVarWebChat: null,
      directlineUrl: null,
      theURL: "https://087eb5da9d06ea878df1ef50e1800e.a2.environment.api.powerplatform.com/powervirtualagents/botsbyschema/cra66_botTestMatteo/directline/token?api-version=2022-03-01-preview",
    };
  },
  mounted() {
    let chatBotLib = document.createElement("script");
    chatBotLib.setAttribute("src", "https://cdn.botframework.com/botframework-webchat/latest/webchat.js");
    document.head.appendChild(chatBotLib);

    this.init();
  },
  methods: {
    init() {
      this.buttonListener();

      const environmentEndPoint = this.theURL.slice(0, this.theURL.indexOf("/powervirtualagents"));
      const apiVersion = this.theURL
        .slice(this.theURL.indexOf("api-version"))
        .split("=")[1];

      const regionalChannelSettingsURL = `${environmentEndPoint}/powervirtualagents/regionalchannelsettings?api-version=${apiVersion}`;

      fetch(regionalChannelSettingsURL)
        .then((response) => response.json())
        .then((data) => {
          this.directlineUrl = data.channelUrlsById.directline;
        })
        .catch((err) => console.error("An error occurred: " + err));
    },
    buttonListener() {
      var cbcontainer = document.createElement("div");
      cbcontainer.classList.add("cb-container");
      cbcontainer.setAttribute("id", "cb-container");

      var cbcontainertopbar = document.createElement("div");
      cbcontainertopbar.innerHTML = this.chatBotTopBarTitle;
      cbcontainertopbar.classList.add("cb-top-bar");
      cbcontainertopbar.setAttribute("id", "cb-top-bar");
      cbcontainer.appendChild(cbcontainertopbar);

      var cbclosebtn = document.createElement("span");
      cbclosebtn.classList.add("cb-close-button");
      cbclosebtn.setAttribute("id", "cb-close-button");
      cbcontainertopbar.appendChild(cbclosebtn);

      var cbwebchat = document.createElement("div");
      cbwebchat.classList.add("cb-webchat");
      cbwebchat.setAttribute("id", "cb-webchat");
      cbcontainer.appendChild(cbwebchat);

      document.body.appendChild(cbcontainer);

      this.cbVarButton = document.getElementById("cb-floatingBtn");

      this.cbVarContainer = cbcontainer;
      this.cbVarWebChat = cbwebchat;

      cbclosebtn.addEventListener("click", () => {
        this.cbVarContainer.style.display = "none";
      });

      this.cbVarButton.addEventListener("click", () => {
        this.loadChatBotFunc();
      });
    },
    loadChatBotFunc() {
      if (!this.directlineUrl) {
        console.error("Direct Line URL not available yet.");
        return;
      }

      //you create the dom floating contain
      this.cbVarContainer.style.display = "block";

      fetch(this.theURL)
        .then((response) => response.json())
        .then((conversationInfo) => {
          const directLine = window.WebChat.createDirectLine({
            domain: `${this.directlineUrl}v3/directline`,
            token: conversationInfo.token,
          });

          // Send a special "on conversation start" activity
          directLine
            .postActivity({
              type: "event",
              name: "startConversation",
              value: "start",
            })
            .subscribe({
              next: (id) => console.log(`Posted activity, assigned ID ${id}`),
              error: (err) => console.log(`Error posting activity ${err}`),
            });

          window.WebChat.renderWebChat(
            {
              directLine,
              styleOptions: this.styleOptions,
            },
            this.cbVarWebChat
          );
        })
        .catch((err) => console.error("An error occurred: " + err));
    },
  },
};
</script>

<style scoped>
#cb-floatingBtn {
    cursor: pointer;
    color: #fff;
    font-size: 15px;
}
</style>
